<template>
  <div style="height: 100%;">
    <component :config="config" :is="currentComponent"></component>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      config: {},
      currentComponent:""
    };
  },
  components: {
    webPage: () => import("./webPage.vue"),
    mPageBak: () => import("./mPage.vue"),
    mPage: () => import("./mPage.vue"), //新版小红书落地页
  },
  computed: {
    app_download_url() {
      if (
        Array.isArray(this.config.app_download_url) &&
        this.config.app_download_url.length > 0
      ) {
        return this.config.app_download_url[0].url;
      }
      return "";
    }
  },
  methods: {
    isMobile() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
        userAgent
      );
    },
    checkDeviceByScreen(){
      const mobileBreakpoint = 768
      return window.innerWidth <= mobileBreakpoint
    }
  },
  created() {
    var that = this;
    this.currentComponent = (that.isMobile() || that.checkDeviceByScreen()) ? "mPage" : "webPage";
    window.addEventListener("resize",function (){
      that.currentComponent = (that.isMobile() || that.checkDeviceByScreen()) ? "mPage" : "webPage";
    })
  },
};
</script>
